import { useEffect } from 'react';
import L from 'leaflet';
import { useTranslation } from 'react-i18next';


const IndexLegend = ({ map, legends, unit, unit_ar }) => {
  // const { t } = useTranslation();
  const {i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';

  useEffect(() => {
    if (!map || !legends) return;
    const legend = L.control({ position: 'bottomright' });

    legend.onAdd = () => {
      const div = L.DomUtil.create('div', 'info legend');
      div.innerHTML = `
        <p class="legend-unit">${isArabic ? (unit_ar ? unit_ar : (unit ? unit : '')) : (unit ? unit : '')}
        </p>
        ${legends
          .map(
            (item) => `
          <div class="legend-item">
            <i style="background: ${item.color}"></i>
            <span>${isArabic? item.label_ar? item.label_ar : item.label : item.label}</span>
          </div>
        `
          )
          .join("")}`;
      L.DomEvent.disableScrollPropagation(div);
      L.DomEvent.disableClickPropagation(div);
      return div;
    };

    const toggleButton = L.control({ position: 'bottomright' });

    toggleButton.onAdd = () => {
      const button = L.DomUtil.create('button', 'legend-toggle-btn');
      button.innerHTML = isArabic? 'Legend إظهار/إخفاء' :'Toggle Legend';
      button.style.padding = '6px 10px';
      button.style.cursor = 'pointer';
      button.style.backgroundColor = 'white';
      button.style.border = '2px solid rgba(0,0,0,0.2)';
      button.style.borderRadius = '10px';
      button.style.display = 'none'; // Initially hidden for desktop

      L.DomEvent.on(button, 'click', () => {
        const legendElement = legend.getContainer();
        if (legendElement) {
          legendElement.style.display =
            legendElement.style.display === 'none' ? 'block' : 'none';
        }
      });

      L.DomEvent.disableClickPropagation(button);
      return button;
    };

    legend.addTo(map);
    toggleButton.addTo(map);

    const mediaQuery = window.matchMedia("(max-width: 768px)");

    const updateVisibility = () => {
      const legendElement = legend.getContainer();
      const toggleElement = toggleButton.getContainer();
      if (!legendElement || !toggleElement) return;

      if (mediaQuery.matches) {
        toggleElement.style.display = 'block'; // Show toggle button on small screens
        legendElement.style.display = 'none'; // Hide legend by default on small screens
      } else {
        toggleElement.style.display = 'none'; // Hide toggle button on desktop
        legendElement.style.display = 'block'; // Always show legend on desktop
      }
    };

    mediaQuery.addEventListener("change", updateVisibility);
    updateVisibility();

    return () => {
      legend.remove();
      toggleButton.remove();
      mediaQuery.removeEventListener("change", updateVisibility);
    };
  }, [map, legends, unit]); 

  return null;
};

export default IndexLegend;
